/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getTransmittalStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getTransmittalStatusByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetTransmittalStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getTransmittalStatusByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getTransmittalStatusByIdPayloadRegExpTwo)]).optional()
});

export type GetTransmittalStatusById = zod.input<typeof GetTransmittalStatusById>;
export type GetTransmittalStatusByIdOutput = zod.output<typeof GetTransmittalStatusById>;
